import { TYPE_WRAPPER } from '../constants/type-wrapper.const.mjs';
import { Token } from '../token.class.mjs';
import { isTypeWrapper } from './is-type-wrapper.util.mjs';
/**
 * Helper function used in the injection-related decorators to resolve the received identifier to
 * an eager type when possible or to a lazy type when cyclic dependencies are possibly involved.
 *
 * @param typeOrIdentifier a service identifier or a function returning a type acting as service identifier or nothing
 * @param target the class definition of the target of the decorator
 */
export function resolveToTypeWrapper(typeOrIdentifier) {
    /**
     * ? We want to error out as soon as possible when looking up services to inject, however
     * ? we cannot determine the type at decorator execution when cyclic dependencies are involved
     * ? because calling the received `() => MyType` function right away would cause a JS error:
     * ? "Cannot access 'MyType' before initialization", so we need to execute the function in the handler,
     * ? when the classes are already created. To overcome this, we use a wrapper:
     * ?  - the lazyType is executed in the handler so we never have a JS error
     * ?  - the eagerType is checked when decorator is running and an error is raised if an unknown type is encountered
     */
    let typeWrapper;
    const inputType = typeof typeOrIdentifier;
    /** If requested type is explicitly set via a string ID or token, we set it explicitly. */
    if (typeOrIdentifier && (inputType === 'string' || typeOrIdentifier instanceof Token || inputType === 'function')) {
        typeWrapper = {
            [TYPE_WRAPPER]: 0 /* TypeWrapperStamp.Generic */,
            /** We have to use 'as any' casts here due to moving the "typeof" checks to a constant. */
            eagerType: typeOrIdentifier,
            lazyType: () => typeOrIdentifier,
        };
    }
    else if (inputType === 'object' && isTypeWrapper(typeOrIdentifier)) {
        /**
         * Any arguments which are type-wrappers shouldn't be modified; instead, they should
         * be directly passed to the caller.
         * This allows for functions such as {@link Lazy} and {@link TransientRef} to function.
         */
        return typeOrIdentifier;
    }
    return typeWrapper;
}
//# sourceMappingURL=resolve-to-type-wrapper.util.mjs.map